import { type ReactNode } from 'react'

interface ConversationContainerProps {
	children: ReactNode
}

export const ConversationContainer: React.FC<ConversationContainerProps> = ({
	children,
}) => (
	<div className="transition-width relative flex h-full w-full flex-1 flex-col items-stretch justify-between overflow-hidden">
		{children}
	</div>
)
